<template>
  <AuthWrapper>
    <template v-slot:header>
      Forgot Password
    </template>

    <template v-slot:main-action>
      <v-btn class="center-button" color="primary" type="submit" @click="requestForgotPassword">Reset Password</v-btn>
    </template>

    <template v-slot:footer-link>
      <router-link to="/login" style="cursor:pointer;">
        Return to Login
      </router-link>
    </template>

    <template v-slot:default>
      <v-form ref="form" class="mx-2" v-model="valid" lazy-validation @keyup.native.enter="requestForgotPassword">
        <v-text-field
          name="login"
          label="E-mail"
          type="email"
          v-model="email"
          :rules="emailRules"
        ></v-text-field>
      </v-form>
    </template>

  </AuthWrapper>
</template>

<script>
import {recaptcha} from "@/mixins/captcha";
import AuthWrapper from "@/layouts/auth/components/AuthWrapper";

export default {
  name: "ForgotPassword",
  mixins: [recaptcha],
  components: {
    AuthWrapper
  },
  data: () => ({
    email: '',
    valid: null,
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
    ]
  }),
  metaInfo () {
    return {
      title: "Forgot Password"
    }
  },
  methods: {
    async requestForgotPassword() {
      const valid = this.$refs.form.validate();

      if (!valid) {
        const detail = "Please enter all fields required";
        await this.$store.dispatch("notification/triggerError", { detail });
        return;
      }

      await this.$store.dispatch("loader/loaderInitiate", { title: "Requesting password reset" });

      const captcha = await this.recaptchaToken();

      const result = await this.$store.dispatch("auth/passwordForgot", { email: this.email, captcha: captcha });

      await this.$store.dispatch("loader/loaderCancel");

      if (result) {
        await this.$store.dispatch("notification/triggerSuccess", { detail: "If the e-mail account exists we will send you a link to change your password" });
      }
    },
  },
}
</script>

<style scoped>

</style>
